module.exports = __webpack_public_path__ + "img/Parker Moore.ea9fb314.jpg";